const data = [
  {
    id: 1,
    title: "What is FAQ ?",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporisedita cum ullam blanditiis harum. Placeat vero ab voluptatem ipsum amet, hic aliquid sapiente quod laboriosam mollitia eaque earum exercitationem.",
  },
  {
    id: 2,
    title: "Why FAQ is important ?",
    description:
      "Lorem ipsum derat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullam blanditiis harum. Placeat vero ab voluptatem ipsum amet, hic aliquid sapiente quod laboriosam mollitia eaque earum exercitationem.",
  },
  {
    id: 3,
    title: "Who creates a FAQ and Why?",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam e",
  },
  {
    id: 4,
    title: "Who developed the FAQ answer?",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullam blanditiis harum. Placeat vero ab voluptatem ipsum amet, hic al",
  },
  {
    id: 5,
    title: "What is frequently asked questions?",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullam blanditiis harum. Placeat vero ab voluptatem ipsu",
  },
  // {
  //   id: 6,
  //   title: "What is react?",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cumolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ",
  // },
  // {
  //   id: 7,
  //   title: "How redux connected with react?",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam exped",
  // },
  // {
  //   id: 8,
  //   title: "How to build and run react project?",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum udolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum u",
  // },
  // {
  //   id: 9,
  //   title: "When react initiated its journey?",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullam blanditiis harum. Placeat vero ab voluptatem ipsum amet, edita cum ullam blanditiis harum. Placeat vero ab voluptatem ipsum amet, h",
  // },
  // {
  //   id: 10,
  //   title: "Who is the founder of react?",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullaconsectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullaconsectetur adipisicing elit. Labore ratione nobis quaerat quasi at facilis placeat suscipit officia corporis ipsum deserunt nesciunt dolor voluptatum beatae iusto possimus vel, excepturi, nam expedita cum ullam",
  // },
];

export default data;
